import { useTranslation } from 'react-i18next';
import { Container, Grid, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import HandshakeIcon from '@mui/icons-material/Handshake';
import VerifiedIcon from '@mui/icons-material/Verified';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Section, SectionTitle, AnimatedBox } from '../../components/ui';

const FeatureCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  padding: theme.spacing(3),
  borderRadius: '16px',
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  transition: 'all 0.3s ease',

  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    transform: 'translateX(8px)',
    borderColor: 'rgba(0, 212, 255, 0.3)',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  width: '64px',
  height: '64px',
  minWidth: '64px',
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.accent.gradient,

  '& svg': {
    fontSize: '28px',
    color: '#FFFFFF',
  },
}));

const features = [
  { key: 'innovation', icon: <LightbulbIcon /> },
  { key: 'partnership', icon: <HandshakeIcon /> },
  { key: 'quality', icon: <VerifiedIcon /> },
  { key: 'results', icon: <TrendingUpIcon /> },
];

export default function WhyNexfahSection() {
  const { t } = useTranslation();

  return (
    <Section variant="gradient">
      <Container maxWidth="lg">
        <SectionTitle
          title={t('whyNexfah.title')}
          subtitle={t('whyNexfah.subtitle')}
          light
        />

        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={6} key={feature.key}>
              <AnimatedBox
                animation="fadeInUp"
                delay={`${index * 0.1}s`}
              >
                <FeatureCard>
                  <IconWrapper>{feature.icon}</IconWrapper>
                  <Box>
                    <Typography
                      variant="h5"
                      sx={{
                        color: '#FFFFFF',
                        fontWeight: 600,
                        mb: 1,
                      }}
                    >
                      {t(`whyNexfah.${feature.key}.title`)}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: 'rgba(255, 255, 255, 0.7)',
                        lineHeight: 1.7,
                      }}
                    >
                      {t(`whyNexfah.${feature.key}.description`)}
                    </Typography>
                  </Box>
                </FeatureCard>
              </AnimatedBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}
